import { apiConfig } from '../../services/apiConfig';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';

// const API_NAMESPACE = 'ns';

export const NS_CONSTANTS = {
  // NS_BASE_URL: `${apiConfig.serviceApi}/${API_NAMESPACE}`,
  NS_BASE_URL: `${apiConfig.serviceApi}/amls/common`,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    // Authorization: `${TOKEN_ID}`
    Authorization: `Bearer ${TOKEN_ID}`
  }),
  GET_SUCCESS_DATA: 'getSuccessData',
  GET_FAILURE_DATA: 'getFailData',
  GET_DATA: 'getData'
};

export const NSIAD_TAB_LIST = [
  'Matching Config List',
  'Run Instance List',
  'Run Instance Summary',
  'NS Alert List',
  'TS Alert List',
  'NS Alert Detail',
  'TS Alert Detail',
  'Watchlist List',
  'Whitelist List',
  'Ticket List'
];
export const NSIAD_TAB_PAGEID_LIST = [
  'NS_IAD_MATCHING_CONFIG_LIST',
  'NS_IAD_RUN_INSTANCES',
  'NS_IAD_RUN_INSTANCE_SUMMARY',
  'NS_IAD_ALERTS_LIST',
  'TS_IAD_ALERTS_LIST',
  'NS_IAD_ALERT_DETAILS',
  'TS_IAD_ALERT_DETAILS',
  'NS_IAD_WATCHLISTS',
  'NS_IAD_WHITELIST',
  'NS_IAD_TICKETS'
];

export const BULK_SCANNING_FLOW = {
  SCAN: 'SCAN',
  SCAN_SUCCESS: 'SCAN_SUCCESS',
  SCAN_FAILED: 'SCAN_FAILED'
};

export const BULK_SCREENING_FLOW = {
  SCREEN: 'SCREEN',
  SCREEN_SUCCESS: 'SCREEN_SUCCESS',
  SCREEN_FAILED: 'SCREEN_FAILED',
  PROGRESS_ERROR: 'PROGRESS_ERROR'
};
